import OpenAI from "openai";

/**
 * Pure function to generate updated post content with AI
 * @param {Object} options
 * @param {Object} options.post - The post object containing content and linkSuggestions
 * @param {string} options.apiKey - OpenAI API key
 * @param {string} options.model - OpenAI model
 * @param {string} [options.instructions] - Optional custom instructions
 * @returns {Promise<{outputText: string, updatedPost: Object}>}
 */
export const GenerateUpdatedPostContent = async ({
  post,
  targetUrl,
  apiKey = process.env.REACT_APP_OPENAI_API_KEY,
  model = "gpt-5-mini",
  instructions = `Please generate only the updated article content with link suggestions naturally integrated. Do not include any introductions, explanations, or closing statements—return only the fully updated content. Do not include partial links, and ensure that all added external links are set to nofollow.`,
}) => {
  if (!apiKey || !post) {
    throw new Error("API Key and post object are required.");
  }

  // Helper: format link suggestions
  function formatLinkSuggestions(suggestions) {
    if (!suggestions || suggestions.length === 0) return targetUrl;
    return suggestions
      .map(
        (sugg, idx) =>
          `${idx + 1}.\nAnchor Text: ${sugg.anchorText}\nExact Placement: ${sugg.exactPlacement}\nUpdated Paragraph: ${sugg.updatedParagraph}`
      )
      .join('\n\n');
  }

  // Helper: format original content
  const formatOriginalContent = (content) => {
    if (!content) return "";
    return `\`\`\`\n${content}\n\`\`\``;
  };

  // Build final query
  const buildFinalQuery = () => {
    const sections = [];
    const linkSuggestionsText = formatLinkSuggestions(post.linkSuggestions);
    if (linkSuggestionsText) sections.push("Link Suggestions: \n" + linkSuggestionsText);
    const originalContentText = formatOriginalContent(post.content);
    if (originalContentText) sections.push("Original Content: \n" + originalContentText);
    if (instructions.trim()) sections.push("Instructions: \n" + instructions);
    return sections.join("\n\n");
  };

  const finalQuery = buildFinalQuery();
  console.log("Update content prompt", finalQuery);

  try {
    const openai = new OpenAI({ apiKey, dangerouslyAllowBrowser: true });
    const response = await openai.responses.create({
      model,
      input: finalQuery,
    });

    const outputText = response.output_text || "No output from AI.";

    // Update post newContents
    // const updatedPost = {
    //   ...post,
    //   newContents: post.newContents ? [...post.newContents, outputText] : [outputText],
    // };

    // return { outputText, updatedPost };
    return response.output_text;
  } catch (error) {
    throw new Error("Error generating AI response: " + error.message);
  }
};
